import * as React from 'react';
import { Svg } from '../Svg';

const mimeTypes = [
  'application/msword',
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  'application/vnd.ms-excel',
  'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  'application/vnd.ms-powerpoint',
  'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  'image/jpeg',
  'image/png',
  'application/pdf',
];

interface IFileInputProps {
  handleFileUpload: (file: any) => void;
}

export const FileInput: React.SFC<IFileInputProps> = ({ handleFileUpload }) => {
  const fileInputRef = React.createRef();

  const openFileDialog = () => {
    if (fileInputRef) {
      (fileInputRef as any).current.click();
    }
  };

  const handleChange = async (e: React.ChangeEvent<Element>) => {
    const file = (e.target as any).files[0];
    handleFileUpload(file);
  };

  return (
    <div
      className='d-flex flex-column align-items-center'
      style={{ cursor: 'pointer' }}
      onClick={openFileDialog}
    >
      <Svg width={48} height={48} fill='dark' src='plus' />
      <span className='text-center dark mt-1'>Ajouter un fichier</span>
      <input
        accept={mimeTypes.join(',')}
        type='file'
        ref={fileInputRef as any}
        onChange={handleChange}
        style={{ display: 'none' }}
      />
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/shared/Files/FileInput.tsx